export class RecuperarSenhaFormModel {
    constructor(
        public email: string
    ){}
}